exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Gxeo{display:block;position:relative;float:left;width:100%}", ""]);

// exports
exports.locals = {
	"root": "Gxeo",
	"root": "Gxeo"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"camelCase":true,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:4]","minimize":true}!../~/postcss-loader?pack=default!./components/CategoriesSidebar/CategoriesSidebar.css
// module id = 225
// module chunks = 0